import { faFloppyDisk, faPen, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardContent, IconButton, Slider, Stack } from '@mui/material';
import { useState } from 'react';

import CheckPermissions from '@/components/CheckPermissions';
import LargeCard from '@/components/LargeCard';
import { PERMISSIONS } from '@/constants/auth.constants';
import useDraftState from '@/hooks/useDraftState';
import useStyles from '@/pages/Administration/AdministrationGeneral/AdministrationGeneral.styles';

import emailTemplateMarks from './NewTicketEmailTemplate.constants';
import type { NewTicketEmailTemplateProps } from './NewTicketEmailTemplate.types';
import {
  BasicTicketTemplate,
  FullTicketTemplate,
  ParanoidTicketTemplate
} from './Templates';

const NewTicketEmailTemplate = (props: NewTicketEmailTemplateProps) => {
  const { classes } = useStyles();
  const { handleSave, orgInfo } = props;
  const [editing, isEditing] = useState<boolean>(false);
  const [updatedOrgInfo, updateDraft, resetDraft] = useDraftState(orgInfo);
  const sliderValue = updatedOrgInfo.email_template_id || 3;

  const handleSliderChange = (_event: Event, newValue: number | number[]) => {
    updateDraft({ email_template_id: newValue as number });
  };

  return (
    <LargeCard
      title="New Ticket Email Template"
      rightContent={
        <CheckPermissions permissions={PERMISSIONS.ADMIN_UPDATE}>
          {editing ? (
            <Stack direction="row">
              <IconButton
                onClick={() => {
                  isEditing(!editing);
                  handleSave(updatedOrgInfo);
                }}
              >
                <FontAwesomeIcon size="xs" icon={faFloppyDisk} />
              </IconButton>
              <IconButton
                onClick={() => {
                  isEditing(!editing);
                  resetDraft();
                }}
              >
                <FontAwesomeIcon size="xs" icon={faXmark} />
              </IconButton>
            </Stack>
          ) : (
            <IconButton onClick={() => isEditing(!editing)}>
              <FontAwesomeIcon size="xs" icon={faPen} />
            </IconButton>
          )}
        </CheckPermissions>
      }
    >
      <CardContent className={classes.sliderCardContent}>
        <Slider
          className={classes.slider}
          onChange={handleSliderChange}
          defaultValue={2}
          value={sliderValue}
          step={1}
          aria-label="Default"
          marks={emailTemplateMarks}
          disabled={!editing}
          min={1}
          max={3}
        />
        {sliderValue === 1 && <ParanoidTicketTemplate />}
        {sliderValue === 2 && <BasicTicketTemplate />}
        {sliderValue === 3 && <FullTicketTemplate />}
      </CardContent>
    </LargeCard>
  );
};

export default NewTicketEmailTemplate;
